/**
 * riderWorkStatus.constants
 * 라이더 근무 현황 관련 상수 정의
 */

/** 근무 현황 조회 API 타임아웃 (ms) — 쿼리 시간이 30초 이상 소요될 수 있음 */
export const WORK_STATUS_API_TIMEOUT = 120000; // 2분

/** 엑셀 다운로드 API 타임아웃 (ms) */
export const WORK_STATUS_EXCEL_TIMEOUT = 300000; // 5분

/** 기본 조회 기간 (일) — 오늘 기준 N일 전 ~ 오늘 */
export const DEFAULT_DATE_RANGE_DAYS = 7;
